import { computed, defineComponent, inject, ref } from "vue";
import { type SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";
import ErrorMessage from "../../Shared/ErrorMessage";
import html_iway from "./template.iway.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: { ErrorMessage },
  props: {
    className: {
      type: String,
      default: ""
    }
  },
  emits: {
    next: () => true,
  },
  setup(_props: any, { emit }: SetupContext) {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    const productId: number = 2;
    const error = ref("");
    const optionVariants = computed(() => {
      const variants = orderService?.availableVariants?.value?.filter(
        (v) => v.product_id == productId,
      );
      return variants ?? [];
    });
    const currentVariantId = computed(() => {
      return (
        orderService?.currentItems?.value?.filter((it) => {
          return it.product_id == productId;
        })[0]?.product_variant_id ?? 0
      );
    });
    const vatType = computed(() => {
      return orderService?.currentVatType?.value || "inclusive";
    });

    // methods
    const next = () => {
      emit("next");
    };

    const selectOptions = computed(() => {
      const options = optionVariants.value.map((v) => {
        let label = v.abo;
        const prices = [];
        if ("inclusive" == vatType.value) {
          if (0 < v.price_fix_incl) {
            prices.push(`${priceFormatter?.formatPrice(v.price_fix_incl)} ${t('Options_FixIp_NonRecurring')}`);
          }
          if (0 < v.price_rec_incl) {
            prices.push(`${priceFormatter?.formatPrice(v.price_rec_incl)} ${t('Options_FixIp_Monthly')}`);
          }
        } else {
          if (0 < v.price_fix) {
            prices.push(`${priceFormatter?.formatPrice(v.price_fix)} ${t('Options_FixIp_NonRecurring')}`);
          }
          if (0 < v.price_rec) {
            prices.push(`${priceFormatter?.formatPrice(v.price_rec)} ${t('Options_FixIp_Monthly')}`);
          }
        }
        if (prices.length > 0) {
          label += ` - ${prices.join(", ")}`;
        }
        return { value: v.id, label };
      });
      return options;
    });

    const handleChange = async (event: Event) => {
      const newId = (event.target as HTMLSelectElement).value;
      error.value = "";
      try {
        const id = Number(newId);
        if (id == 0 && 0 != currentVariantId.value) {
          await orderService?.removeFromCart(currentVariantId.value, "", 1);
        } else if (id != currentVariantId.value) {
          await orderService?.addToCart(id, "", 1);
        }
      } catch (err) {
        error.value = err instanceof Error ? err.message : String(err);
      }
    };

    return {
      error,
      currentVariantId,
      optionVariants,
      priceFormatter,
      handleChange,
      selectOptions,
      t,
      vatType,
      next,
    };
  },
} as any);
